﻿﻿import { LogisticsPlanAudience } from '../enums/index';

export interface ILogisticsRequest {
    recipientId: number;
    recipientSurgeonContactId: number;
    donorId: number;
    donorSurgeonContactId: number;
    logisticsProvider: number;
    kidneyPickupDateTime: string;
    kidneyPickupDateTimeBackup: string;
    kidneyPickupDateTimeActual: string;
    pickupGroundMiles: number;
    pickupGroundMilesBackup: number;
    pickupGroundMilesActual: number;
    dropoffGroundMiles: number;
    dropoffGroundMilesBackup: number;
    dropoffGroundMilesActual: number;
    kidneyArrivalDateTime: string;
    kidneyArrivalDateTimeBackup: string;
    kidneyArrivalDateTimeActual: string;
    flightRouteOrGround: string;
    flightRouteOrGroundBackup: string;
    flightRouteOrGroundActual: string;
    transportMethod: number;
    transportMethodBackup: number;
    transportMethodActual: number;
    transportCost: number;
    transportCostBackup: number;
    transportCostActual: number;
    flightCarrierAndNumber: string;
    flightCarrierAndNumberBackup: string;
    flightCarrierAndNumberActual: string;
    flightDepartureTime: string;
    flightDepartureTimeTz: string;
    flightDepartureTimeBackup: string;
    flightDepartureTimeBackupTz: string;
    flightDepartureTimeActual: string;
    flightDepartureTimeActualTz: string;
    flightArrivalTime: string;
    flightArrivalTimeTz: string;
    flightArrivalTimeBackup: string;
    flightArrivalTimeBackupTz: string;
    flightArrivalTimeActual: string;
    flightArrivalTimeActualTz: string;
    leg2DepartureTime: string;
    leg2DepartureTimeTz: string;
    leg2DepartureTimeActual: string;
    leg2DepartureTimeActualTz: string;
    leg2DepartureTimeBackup: string;
    leg2DepartureTimeBackupTz: string;
    leg2ArrivalTime: string;
    leg2ArrivalTimeTz: string;
    leg2ArrivalTimeActual: string;
    leg2ArrivalTimeActualTz: string;
    leg2ArrivalTimeBackup: string;
    leg2ArrivalTimeBackupTz: string;
    tenderedToAirlineActual: string;
    tenderedToAirlineActualTz: string;
    recoveredFromAirlineActual: string;
    recoveredFromAirlineActualTz: string;
    deliveryLocation: string;
    deliveredTo: string;
    activeLogisticsPlan: string;
    jobNumber: string;
    chainId: number;
    clusterNumber: number;
    position: number;
    notes: string;
    audience: LogisticsPlanAudience;
}
